module.exports = __webpack_public_path__ + "static/media/video-thumb-small.3f1e69d8.svg";